export type LookInsidePage = {
  src: string
  alt: string
  caption: string
}

/** Real pages from Volume 4, Connect. Vertical 9:16 renders, in this order. */
export const lookInsidePages: LookInsidePage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/5qwUkKiuRPkK8qxjswGxUs/carrusel-01-tapa-connect.jpg',
    alt: 'Volume 4 cover',
    caption: '9 complete sessions · 11 worksheets',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/srjPgvntKcuEgF8aPh2KEa/carrusel-02-week28-circles-of-closeness.jpg',
    alt: 'Week 28 Circles of Closeness session page',
    caption: 'Every session step by step',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/cegKSuB2nfB89SiW4thxLy/carrusel-03-week31-boundary-fence.jpg',
    alt: 'Week 31 My Boundary Fence session page',
    caption: 'Quick Win, Snag and 30-minute notes',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/44b86RATivUN9DPGwoiY1U/carrusel-04-ws39-three-doors.jpg',
    alt: 'WS-39 Three Doors worksheet',
    caption: 'Printable worksheets, ready to use',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/6v3ZjyMRWy9zYTNLSw35NY/carrusel-05-troubleshooting.jpg',
    alt: 'Troubleshooting page for group sessions',
    caption: 'What to say when a group gets hard',
  },
]
